export default "__VITE_ASSET__623ccc13__"